import React, { Fragment } from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}
export function Modal({
  isOpen,
  onClose,
  title,
  children,
  footer,
  size = 'md'
}: ModalProps) {
  if (!isOpen) return null;
  const sizes = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl'
  };
  return <div className="fixed inset-0 z-50 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true" data-id="element-289">
      <div className="flex min-h-screen items-end justify-center px-4 pt-4 pb-20 text-center sm:block sm:p-0" data-id="element-290">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true" onClick={onClose} data-id="element-291"></div>

        {/* Center trick */}
        <span className="hidden sm:inline-block sm:h-screen sm:align-middle" aria-hidden="true" data-id="element-292">
          &#8203;
        </span>

        {/* Modal Panel */}
        <div className={`
          inline-block transform overflow-hidden rounded-lg bg-white text-left align-bottom shadow-xl transition-all 
          sm:my-8 sm:w-full sm:align-middle ${sizes[size]}
        `} data-id="element-293">
          <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4" data-id="element-294">
            <div className="flex items-start justify-between mb-4" data-id="element-295">
              <h3 className="text-lg font-medium leading-6 text-gray-900" id="modal-title" data-id="element-296">
                {title}
              </h3>
              <button type="button" className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none" onClick={onClose} data-id="element-297">
                <span className="sr-only" data-id="element-298">Close</span>
                <X className="h-6 w-6" aria-hidden="true" data-id="element-299" />
              </button>
            </div>
            <div className="mt-2" data-id="element-300">{children}</div>
          </div>
          {footer && <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6" data-id="element-301">
              {footer}
            </div>}
        </div>
      </div>
    </div>;
}